var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYodleeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 27,
    viewBox: "0 0 80 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2295 12.0206V6.11475H24.6576V7.0731H22.3495V8.46018H24.3613L24.1658 9.43485H22.3495V11.0623H24.6651V12.0206H21.2295Z",
    fill: "#0069AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.856 12.0206L28.0782 7.95431V12.0206H27.0264V6.11475H28.0945L30.7449 9.98376V6.11475H31.7967V12.0206H30.856Z",
    fill: "#0069AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.08 12.046H35.9689L33.7363 6.06152H34.9956L36.5674 10.5818L38.1156 6.11493H39.2948L37.08 12.046Z",
    fill: "#0069AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2117 12.089C48.4932 12.089 47.8784 11.9273 47.3584 11.6781L47.5288 10.6426C48.0251 10.9334 48.6399 11.1648 49.2295 11.1648C49.7525 11.1648 50.111 10.917 50.111 10.4453C50.111 10.0091 49.9051 9.82962 49.0503 9.46171C47.9036 8.99143 47.4428 8.61462 47.4428 7.6978C47.4428 6.65341 48.2473 6.04517 49.351 6.04517C50.0177 6.04517 50.4784 6.18165 50.9065 6.40418L50.7362 7.43225C50.308 7.15039 49.8043 6.9694 49.3421 6.9694C48.7791 6.9694 48.5303 7.24385 48.5303 7.60286C48.5303 7.97967 48.7184 8.15918 49.5377 8.50187C50.7525 8.99736 51.1969 9.4172 51.1969 10.334C51.1954 11.4897 50.3495 12.089 49.2117 12.089Z",
    fill: "#0069AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9328 7.09832V12.0206H54.7965V7.09832H53.0439V6.11475H57.7373L57.5151 7.09832H55.9328Z",
    fill: "#0069AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6187 12.0206L60.8409 7.95431V12.0206H59.7891V6.11475H60.8587L63.5076 9.98376V6.11475H64.5594V12.0206H63.6187Z",
    fill: "#0069AA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.487 7.09832V12.0206H74.3493V7.09832H72.5967V6.11475H77.2322L77.01 7.09832H75.487Z",
    fill: "#0069AA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4697 12.0089V6.10156H44.8994V7.05991H42.5912V8.447H44.6016L44.406 9.42316H42.5912V11.0506H44.9068V12.0089H41.4697Z",
    fill: "#0069AA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1855 12.0238V6.11646H70.6152V7.07481H68.307V8.4619H70.3174L70.1218 9.43805H68.307V11.0655H70.6226V12.0238H67.1855Z",
    fill: "#0069AA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1674 7.70083C78.7111 7.70083 78.3955 7.38484 78.3955 6.9116C78.3955 6.44133 78.7185 6.11792 79.1674 6.11792C79.6222 6.11792 79.9392 6.43836 79.9392 6.9116C79.9392 7.38039 79.6162 7.70083 79.1674 7.70083ZM79.1674 6.20841C78.8 6.20841 78.5066 6.46061 78.5066 6.91012C78.5066 7.35665 78.8 7.60885 79.1674 7.60885C79.5377 7.60885 79.8311 7.35665 79.8311 6.91012C79.8311 6.46061 79.5348 6.20841 79.1674 6.20841ZM79.3644 7.32995L79.1333 6.98578H79.0681V7.31957H78.874V6.44429H79.1733C79.3733 6.44429 79.4962 6.53924 79.4962 6.70984C79.4962 6.83297 79.4355 6.9116 79.3303 6.95166L79.5644 7.29583L79.3644 7.32995ZM79.16 6.60006H79.0681V6.84781H79.157C79.2488 6.84781 79.3022 6.80775 79.3022 6.72171C79.3022 6.64457 79.2533 6.60006 79.16 6.60006Z",
    fill: "#0069AA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1674 7.70083C78.7111 7.70083 78.3955 7.38484 78.3955 6.9116C78.3955 6.44133 78.7185 6.11792 79.1674 6.11792C79.6222 6.11792 79.9392 6.43836 79.9392 6.9116C79.9392 7.38039 79.6162 7.70083 79.1674 7.70083ZM79.1674 6.20841C78.8 6.20841 78.5066 6.46061 78.5066 6.91012C78.5066 7.35665 78.8 7.60885 79.1674 7.60885C79.5377 7.60885 79.8311 7.35665 79.8311 6.91012C79.8311 6.46061 79.5348 6.20841 79.1674 6.20841ZM79.3644 7.32995L79.1333 6.98578H79.0681V7.31957H78.874V6.44429H79.1733C79.3733 6.44429 79.4962 6.53924 79.4962 6.70984C79.4962 6.83297 79.4355 6.9116 79.3303 6.95166L79.5644 7.29583L79.3644 7.32995ZM79.16 6.60006H79.0681V6.84781H79.157C79.2488 6.84781 79.3022 6.80775 79.3022 6.72171C79.3022 6.64457 79.2533 6.60006 79.16 6.60006Z",
    fill: "#0069AA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6879 18.0067C70.2316 18.0067 69.916 17.6907 69.916 17.2175C69.916 16.7472 70.239 16.4238 70.6879 16.4238C71.1427 16.4238 71.4597 16.7443 71.4597 17.2175C71.4597 17.6863 71.1368 18.0067 70.6879 18.0067ZM70.6879 16.5158C70.3205 16.5158 70.0271 16.768 70.0271 17.2175C70.0271 17.664 70.3205 17.9162 70.6879 17.9162C71.0582 17.9162 71.3516 17.664 71.3516 17.2175C71.3516 16.768 71.0553 16.5158 70.6879 16.5158ZM70.8849 17.6359L70.6538 17.2917H70.5886V17.6255H70.3945V16.7502H70.6938C70.8938 16.7502 71.0168 16.8451 71.0168 17.0157C71.0168 17.1389 70.956 17.2175 70.8508 17.2576L71.0849 17.6017L70.8849 17.6359ZM70.6819 16.9075H70.5901V17.1552H70.679C70.7708 17.1552 70.8242 17.1151 70.8242 17.0291C70.8242 16.952 70.7738 16.9075 70.6819 16.9075Z",
    fill: "#0096D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6344 16.5381L25.5425 20.1831C25.4936 20.2409 25.4418 20.3018 25.427 20.3196C25.4121 20.3374 25.4003 20.3685 25.4003 20.3923C25.4003 20.416 25.4003 20.4946 25.4003 20.5703V22.2704C25.4003 22.3461 25.3381 22.4084 25.2625 22.4084H24.0492C23.9736 22.4084 23.9114 22.3461 23.9114 22.2704V20.5703C23.9114 20.4946 23.9114 20.4145 23.9114 20.3923C23.9114 20.37 23.8995 20.3374 23.8847 20.3196C23.8699 20.3018 23.8181 20.2409 23.7692 20.1831L20.7662 16.6434C20.7173 16.5856 20.7395 16.5381 20.8151 16.5381H22.2892C22.3647 16.5381 22.4655 16.5856 22.5144 16.6449L24.3973 18.9325C24.4447 18.9903 24.5232 19.0853 24.5707 19.1431C24.6181 19.201 24.6951 19.201 24.7425 19.1431C24.7899 19.0853 24.867 18.9918 24.9158 18.9325L26.7988 16.6449C26.8462 16.587 26.9484 16.5381 27.024 16.5381H28.6344Z",
    fill: "#0096D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5528 16.4685C36.4402 16.4685 37.1083 17.0085 37.1083 18.5306V20.4147C37.1083 21.9367 36.4402 22.4767 34.5528 22.4767H31.452C29.5646 22.4767 28.8965 21.9367 28.8965 20.4147V18.5306C28.8965 17.0085 29.5646 16.4685 31.452 16.4685H34.5528ZM31.7661 21.2988H34.2402C35.0817 21.2988 35.5691 21.0555 35.5691 19.8109V19.1299C35.5691 18.357 35.3957 17.642 34.1365 17.642H31.8728C30.6135 17.642 30.4402 18.357 30.4402 19.1299V19.8109C30.4372 20.7544 30.655 21.2988 31.7661 21.2988Z",
    fill: "#0096D6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4433 16.5381H60.6788C60.7544 16.5381 60.8166 16.6004 60.8166 16.6761V17.4208C60.8166 17.4965 60.7544 17.5588 60.6788 17.5588H56.2122C56.1366 17.5588 56.0255 17.5588 55.9633 17.5588C55.9011 17.5588 55.8522 17.6092 55.8522 17.67C55.8522 17.7309 55.8522 17.8436 55.8522 17.9193V18.6566C55.8522 18.7322 55.8522 18.8435 55.8522 18.9058C55.8522 18.9681 55.9025 19.0171 55.9633 19.0171C56.024 19.0171 56.1366 19.0171 56.2122 19.0171H60.4181C60.4937 19.0171 60.5559 19.0794 60.5559 19.155V19.7425C60.5559 19.8182 60.4937 19.8805 60.4181 19.8805H56.2122C56.1366 19.8805 56.0255 19.8805 55.9633 19.8805C55.9011 19.8805 55.8522 19.9309 55.8522 19.9917C55.8522 20.0526 55.8522 20.1653 55.8522 20.241V20.9783C55.8522 21.0539 55.8522 21.1652 55.8522 21.2275C55.8522 21.2883 55.9025 21.3388 55.9633 21.3388C56.024 21.3388 56.1366 21.3388 56.2122 21.3388H60.7929C60.8685 21.3388 60.9307 21.4011 60.9307 21.4767V22.2734C60.9307 22.349 60.8685 22.4113 60.7929 22.4113H54.5011C54.4255 22.4113 54.3633 22.349 54.3633 22.2734V16.6746C54.3633 16.5989 54.4255 16.5366 54.5011 16.5366H59.704C59.7796 16.5366 59.9025 16.5366 59.9781 16.5366H60.8151",
    fill: "#0096D6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2402 16.5381H68.4757C68.5513 16.5381 68.6135 16.6004 68.6135 16.6761V17.4208C68.6135 17.4965 68.5513 17.5588 68.4757 17.5588H64.009C63.9335 17.5588 63.8224 17.5588 63.7602 17.5588C63.6994 17.5588 63.649 17.6092 63.649 17.67C63.649 17.7309 63.649 17.8436 63.649 17.9193V18.6566C63.649 18.7322 63.649 18.8435 63.649 18.9058C63.649 18.9681 63.6994 19.0171 63.7602 19.0171C63.8209 19.0171 63.9335 19.0171 64.009 19.0171H68.215C68.2906 19.0171 68.3528 19.0794 68.3528 19.155V19.7425C68.3528 19.8182 68.2906 19.8805 68.215 19.8805H64.009C63.9335 19.8805 63.8224 19.8805 63.7602 19.8805C63.6994 19.8805 63.649 19.9309 63.649 19.9917C63.649 20.0526 63.649 20.1653 63.649 20.241V20.9783C63.649 21.0539 63.649 21.1652 63.649 21.2275C63.649 21.2883 63.6994 21.3388 63.7602 21.3388C63.8209 21.3388 63.9335 21.3388 64.009 21.3388H68.5898C68.6654 21.3388 68.7276 21.4011 68.7276 21.4767V22.2734C68.7276 22.349 68.6654 22.4113 68.5898 22.4113H62.2979C62.2224 22.4113 62.1602 22.349 62.1602 22.2734V16.6746C62.1602 16.5989 62.2224 16.5366 62.2979 16.5366H67.5024C67.578 16.5366 67.7009 16.5366 67.7765 16.5366H68.6135",
    fill: "#0096D6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5144 16.5381H43.1336H41.8507H41.0403H38.4092V22.4069H41.0403H41.8507H43.5144C45.3544 22.4069 46.4136 20.9337 46.4136 19.5407V19.4042C46.4136 18.0112 45.3544 16.5381 43.5144 16.5381ZM44.8136 19.4918C44.8136 20.4857 44.107 21.2305 42.7899 21.2305H41.8507H41.0403H40.1203H39.8981V21.0079V17.8851V17.6626H40.1203H41.0403H41.8507H42.7899C44.1262 17.6626 44.8136 18.3925 44.8136 19.4013V19.4918Z",
    fill: "#0096D6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0065 16.9238C49.0065 16.9639 49.005 17.0588 49.005 17.1345L49.0065 20.87C49.0065 20.9456 49.0065 21.0569 49.0065 21.1192C49.0065 21.18 49.0568 21.2305 49.1176 21.2305C49.1783 21.2305 49.2909 21.2305 49.3665 21.2305H53.2154C53.2909 21.2305 53.3531 21.2928 53.3531 21.3684V22.2704C53.3531 22.3461 53.2909 22.4084 53.2154 22.4084H47.6554C47.5798 22.4084 47.5176 22.3461 47.5176 22.2704V16.6746C47.5176 16.5989 47.5798 16.5366 47.6554 16.5366H48.8687C48.9442 16.5366 49.0065 16.5989 49.0065 16.6746V16.7132C49.0065 16.7888 49.0065 16.8838 49.0065 16.9238Z",
    fill: "#0096D6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.128906 0.0681152V4.57059L9.23261 7.99899L16.1378 6.09564L0.128906 0.0681152Z",
    fill: "url(#paint0_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23229 13.9404L16.1375 12.0371L13.933 11.2063L7.02637 13.1097L9.23229 13.9404Z",
    fill: "url(#paint1_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.128906 6.00806V10.5076L7.02668 8.60718L0.128906 6.00806Z",
    fill: "url(#paint2_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84002 13.7119L0.128906 15.0115V16.4431L0.137795 16.446L7.04446 14.5427L4.84002 13.7119Z",
    fill: "url(#paint3_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26714 19.8626L16.1383 17.9681V17.9667L13.9516 17.1433L7.04492 19.0467L9.26714 19.8626Z",
    fill: "url(#paint4_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0.128906 22.3801V26.8633L16.1378 22.4513V22.4498L9.26668 19.8625L0.128906 22.3801Z",
    fill: "url(#paint5_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1377 22.45V17.9683L9.2666 19.8627L16.1377 22.45Z",
    fill: "url(#paint6_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02668 13.1096L0.128906 10.512V11.9376L4.84002 13.7119L7.02668 13.1096Z",
    fill: "url(#paint7_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23229 7.99902L7.02637 8.60726L13.933 11.2064L16.1375 10.5996L9.23229 7.99902Z",
    fill: "url(#paint8_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1376 6.0957L9.23242 7.99906L16.1376 10.5997V6.0957Z",
    fill: "url(#paint9_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0.128906 10.5078V10.5123L7.02668 13.1099L13.9334 11.2065L7.02668 8.60742L0.128906 10.5078Z",
    fill: "url(#paint10_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0.128906 11.9377V15.0116L4.84002 13.712L0.128906 11.9377Z",
    fill: "url(#paint11_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04492 14.5427L13.9516 17.1433L16.1383 16.541L9.23307 13.9404L7.04492 14.5427Z",
    fill: "url(#paint12_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0.128906 16.4493V20.9517L7.04446 19.0469L0.137795 16.4463L0.128906 16.4493Z",
    fill: "url(#paint13_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1376 16.5411V12.0371L9.23242 13.9405L16.1376 16.5411Z",
    fill: "url(#paint14_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.137695 16.4461L7.04436 19.0467L13.951 17.1433L7.04436 14.5427L0.137695 16.4461Z",
    fill: "url(#paint15_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.9966,
    y1: 5.11517,
    x2: 1.84829,
    y2: -0.485347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9DDE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.9346,
    y1: 12.7285,
    x2: 2.11726,
    y2: 7.25901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9DDE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 16.0399,
    y1: 10.9075,
    x2: 1.50733,
    y2: 5.15489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9DDE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 15.8834,
    y1: 15.9042,
    x2: 1.92445,
    y2: 10.3787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9DDE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 16.7411,
    y1: 18.6856,
    x2: 2.93934,
    y2: 13.2223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#84CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7497,
    stopColor: "#9FD8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9DDE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 16.0271,
    y1: 22.7686,
    x2: 0.97407,
    y2: 26.8979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 16.1384,
    y1: 20.2095,
    x2: 0.261994,
    y2: 20.2095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9877,
    stopColor: "#30AEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 15.9834,
    y1: 11.3151,
    x2: 0.899109,
    y2: 15.4529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 16.0802,
    y1: 9.44985,
    x2: 1.09688,
    y2: 13.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 16.1383,
    y1: 8.34779,
    x2: 0.261725,
    y2: 8.34779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9877,
    stopColor: "#30AEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 16.1437,
    y1: 10.8586,
    x2: 0.266981,
    y2: 10.8586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9877,
    stopColor: "#30AEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 16.1439,
    y1: 13.4751,
    x2: 0.266935,
    y2: 13.4751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9877,
    stopColor: "#30AEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 16.0668,
    y1: 15.3896,
    x2: 1.0842,
    y2: 19.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 16.1492,
    y1: 16.8343,
    x2: 0.830378,
    y2: 21.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 16.1383,
    y1: 14.2885,
    x2: 0.261725,
    y2: 14.2885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9877,
    stopColor: "#30AEE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 16.1436,
    y1: 16.7948,
    x2: 0.267355,
    y2: 16.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9877,
    stopColor: "#30AEE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYodleeLogo);
export default __webpack_public_path__ + "static/media/yodlee_logo.5f3b70b6116f1012d91121bab28f32f3.svg";
export { ForwardRef as ReactComponent };